import styled from "styled-components";
import { Pagination } from "antd";

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px;
`;

export const TotalText = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
`;

export const StyledPagination = styled(Pagination)`
  display: flex;
  align-items: center;
  margin-left: auto;

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    margin: 0 2px;
    line-height: 30px;
    border-radius: 6px;
  }

  .ant-pagination-item {
    border: 1px solid #e4e4e7;
    background: #fff;

    a {
      color: rgba(0, 0, 0, 0.65);
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    &:hover {
      border-color: #11a7d9;

      a {
        color: #11a7d9;
      }
    }
  }

  .ant-pagination-item-active {
    border-color: #11a7d9;
    background: #11a7d9;

    a {
      color: #fff;
      font-weight: 600;
    }

    &:hover {
      border-color: #11a7d9;

      a {
        color: #fff;
      }
    }
  }

  .ant-pagination-prev button,
  .ant-pagination-next button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #e4e4e7;
    background: #fff;
    color: rgba(0, 0, 0, 0.65);
  }

  .ant-pagination-prev:hover button,
  .ant-pagination-next:hover button {
    border-color: #11a7d9;
    color: #11a7d9;
  }

  .ant-pagination-disabled button,
  .ant-pagination-disabled:hover button {
    border-color: #e4e4e7;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }

  .ant-pagination-item-ellipsis {
    color: rgba(0, 0, 0, 0.45);
  }

  .ant-pagination-options {
    margin-left: 12px;
  }

  .ant-pagination-options-quick-jumper {
    color: rgba(0, 0, 0, 0.65);
    font-family: "Open Sans", sans-serif;
    font-size: 14px;

    input {
      height: 32px;
      border-radius: 6px;
      border: 1px solid #e4e4e7;
      font-family: "Open Sans", sans-serif;

      &:hover,
      &:focus {
        border-color: #11a7d9;
      }
    }
  }
`;
